import Text from './Text';
import { TextProps, TextValueProps } from './types';

export type { TextProps, TextValueProps };
export default Text;
